<template>
    <div class="mainpage">
        <div class="d-flex justify-content-end mb-3">
            <Calendar ref="searchCalendar" @date-select="dateSearch" class="gap" v-model="date" showIcon  selectionMode="range" :manualInput="false" placeholder="Last 30 days" :maxDate="maxDate"/>
        </div>
        <div class="d-flex justify-content-start flex-wrap row-1">
            <div class="metric-cards d-flex justify-content-between flex-wrap">
                <div class="whitelist-metric metric-card">
                    <p class="m-0"> Total URLs </p>
                    <p class="mb-1"> Whitelisted </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-tooltip="getCardsData.whitelistedUrls" v-else class="card-count">
                        {{ millify(getCardsData.whitelistedUrls) }}
                    </div>
                </div>
                <div class="short-metric metric-card">
                    <p class="m-0"> Total URLs </p>
                    <p class="mb-1"> Shortened </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-tooltip="getCardsData.shortenedUrls" v-else class="card-count">
                        {{ millify(getCardsData.shortenedUrls) }}
                    </div>
                </div>
                <div class="domain-metric metric-card">
                    <p class="m-0"> URLs shortened using </p>
                    <p class="mb-1"> Branded domain </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-else class="card-count">
                        0
                    </div>
                </div>
                <div class="subdom-metric metric-card">
                    <p class="m-0"> URLs shortened by using</p>
                    <p class="mb-1"> Custom back halves </p>
                    <Skeleton v-if="whitelistLoader" size="50%" shape="circle"/>
                    <div v-else class="card-count">
                        0
                    </div>
                </div>
            </div>
            <div class="graph-container">
                <div class="type-graph gap2">
                    <Skeleton v-if="whitelistLoader" shape="circle" size="50%"></Skeleton>
                    <ECharts v-else :chartOptions="getCtaTypeMetrics" />
                </div>
                <div class="type-graph">
                    <Skeleton v-if="clickLoader" shape="circle" size="50%"></Skeleton>
                    <ECharts v-else :chartOptions="getClickmetrics" />
                </div>
            </div>
        </div>
        <div class="row-2 graphs">
            <div class="graph-heading">
                Click Trend
            </div>
            <Skeleton v-if="trendLoader" class="card-skeleton"></Skeleton>
            <div v-else class="card-skeleton">
                <ECharts :chartOptions="getClickTrend" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import ECharts from '@/components/common/ECharts.vue'
import moment from 'moment'
import millify from 'millify'

export default {
    name: 'HomePage',
    components: {
        ECharts
    },
    data () {
        return {
            date: [],
            startDay: '',
            endDay: '',
            whitelistLoader: false,
            clickLoader: false,
            trendLoader: false,
            maxDate: null
        }
    },
    methods: {
        millify,
        async dateSearch () {
            if (this.date[1] != null) {
                this.$refs.searchCalendar.overlayVisible = false
                this.fetchClicksAnalytics()
                this.fetchShortenedAnalytics()
                this.fetchWhitelistAnalytics()
                this.fetchClickTrendAnalytics()
            }
        },
        async fetchWhitelistAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.whitelistLoader = true
            await this.$store.dispatch('Dashboards/Dashboard/fetchWhitelistAnalytics', data)
            this.whitelistLoader = false
        },
        async fetchShortenedAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            await this.$store.dispatch('Dashboards/Dashboard/fetchShortenedAnalytics', data)
        },
        async fetchClicksAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.clickLoader = true
            await this.$store.dispatch('Dashboards/Dashboard/fetchClicksAnalytics', data)
            this.clickLoader = false
        },
        async fetchClickTrendAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.trendLoader = true
            await this.$store.dispatch('Dashboards/Dashboard/fetchClickTrendAnalytics', data)
            this.trendLoader = false
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Dashboards/Dashboard', [ 'getCtaTypeMetrics', 'getClickmetrics', 'getClickTrend', 'getCardsData' ])
    },
    async mounted () {
        this.maxDate = new Date()
        this.fetchClicksAnalytics()
        this.fetchShortenedAnalytics()
        this.fetchWhitelistAnalytics()
        this.fetchClickTrendAnalytics()
    }
}
</script>

<style>

</style>
